'use client';

import { singletonHook } from 'react-singleton-hook';
import Env from 'src/environmentVariables/EnvironmentVariables';

const useIsMainnet = () => {
	const isMainnet = Env.sdkEnv === 'mainnet-beta';

	return isMainnet;
};

export default singletonHook(false, useIsMainnet);
